import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsSocketDotIoComponent } from './simple-icons-socket-dot-io.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsSocketDotIoComponent ],
    exports:      [ SimpleIconsSocketDotIoComponent ],
    bootstrap:    []
})
export class SimpleIconsSocketDotIoModule {}
